// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-15GY6","timeImage":"timeImage-2mVND","text":"text-1h5kV","button":"button-3o0rx"};